<script>
import AdminLayout from '@layouts/admin-main'
import PrivateDealList from '@components/admin/private-deal-list'

export default {
  page: {
    title: 'Admin::PrivateDealList',
    meta: [{ name: 'description', content: 'Admin::PrivateDealList' }],
  },
  components: { AdminLayout, PrivateDealList },
}
</script>

<template>
  <AdminLayout>
    <PrivateDealList></PrivateDealList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
